import { render } from "./NewRefferalPage.vue?vue&type=template&id=39ebed32&ts=true"
import script from "./NewRefferalPage.vue?vue&type=script&lang=ts"
export * from "./NewRefferalPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__